import { render, staticRenderFns } from "./loginOtp.vue?vue&type=template&id=1de881ba&scoped=true"
import script from "./loginOtp.vue?vue&type=script&lang=js"
export * from "./loginOtp.vue?vue&type=script&lang=js"
import style0 from "./loginOtp.vue?vue&type=style&index=0&id=1de881ba&prod&lang=sass&scoped=true"
import style1 from "./loginOtp.vue?vue&type=style&index=1&id=1de881ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de881ba",
  null
  
)

export default component.exports